import Home from "./views/Home.vue";
import { NotAuthorized, NotFound, PasswordChanged } from "@modernary/mui/components/common";
import inboxItemRoutes, { inboxItemRouteNames } from "./views/inboxItem/inboxItemRoutes";
import outboxItemRoutes, { outboxItemRouteNames } from "./views/outboxItem/outboxItemRoutes";
import internalRoutingItemRoutes, {
  internalRoutingItemRouteNames,
} from "./views/internalRoutingItem/internalRoutingItemRoutes";

// import loginRoutes from "./views/login/loginRoutes";

// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  notAuthorized: "NotAuthorized",
  passwordChanged: "PasswordChanged",
  inboxItem: {
    ...inboxItemRouteNames,
  },
  outboxItem: {
    ...outboxItemRouteNames,
  },
  internalRoutingItem: {
    ...internalRoutingItemRouteNames,
  },
};

/** @type {import('vue-router').RouterOptions['routes']} */
export const routes = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  {
    path: "/password-changed",
    component: PasswordChanged,
    name: routeNames.passwordChanged,
    meta: { title: "Password Changed" },
  },
  ...inboxItemRoutes,
  ...outboxItemRoutes,
  ...internalRoutingItemRoutes,
  { path: "/:path(.*)", component: NotFound },
];
